export enum UsersDataKeys {
  UserID = 'user_id',
  Profile = 'profile',
  ProfileDisplayName = 'profile.display_name',
  PrimaryEmail = 'primary_email',
  CreatedAt = 'created_at',
}